// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","757":"not-found"}[chunkId] + "." + {"353":"291651a0","757":"75faa04e"}[chunkId] + ".js";
};